import * as Yup from 'yup';

export const ChangePasswordOnSignInSchema = Yup.object().shape({
    newPassword: Yup.string().min(8).required('please provide your password'),
    confirmPassword: Yup.string()
        .required()
        .oneOf([Yup.ref('newPassword')], 'Passwords do not match'),
});

export type ChangePasswordOnSignInDataType = Yup.InferType<
    typeof ChangePasswordOnSignInSchema
>;

type InitialValues = {
    newPassword: string;
    confirmPassword: string;
};

export const changePasswordOnSignInInitialValues: InitialValues = {
    newPassword: '',
    confirmPassword: '',
};

export interface IChangePassword {
    userId: string;
    password: string;
}
